import { render, staticRenderFns } from "./CreateReportFormat.vue?vue&type=template&id=0fd233db"
import script from "./CreateReportFormat.vue?vue&type=script&lang=js"
export * from "./CreateReportFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports